// client/src/modules/marketing/nav.ts
import type { NavItem } from '../types';

export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/marketing' },
  { label: 'Content', path: '/marketing/content' },
  { label: 'PR', path: '/marketing/pr' },
  { label: 'SEO', path: '/marketing/seo' },
  { label: 'Testimonials', path: '/marketing/testimonials', requireManagerOrAdmin: true },
  { label: 'Settings', path: '/marketing/settings', requireManagerOrAdmin: true },
];
